import { procoreClient } from "./client";
import type { SceneReadBackend } from "./errors";

/**
 * Probe the backend that reported a cache miss without raising another backfill signal.
 * BIM Query needs bim_index and metadata; the legacy ping needs the text index,
 * which Black Marlin does not produce. A LIGHT read checks both BIM Query artifacts.
 */
export async function isProcoreSceneReady(params: {
    companyId: number;
    projectId: number;
    sceneId: string;
    sceneVersionId: string;
    signal?: AbortSignal;
    backend?: SceneReadBackend;
}): Promise<boolean> {
    const bimQuery = params.backend === "bim-query";
    const apiVersion = bimQuery ? "v2.1" : "v2.0";
    const endpoint = bimQuery ? "objects/root/children" : "ping";
    return procoreClient<boolean>(
        `/rest/${apiVersion}/companies/${params.companyId}/projects/${params.projectId}/bim/scenes/${params.sceneId}/versions/${params.sceneVersionId}/${endpoint}`,
        {
            method: "GET",
            ...(bimQuery ? { params: { per_page: 1, view: "LIGHT", id_kind: "INTERNAL" } } : {}),
            parseResponse: (res) => res.status === 200,
            signal: params.signal,
        },
    );
}
